import clsx from "clsx";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { GetFileObjectById, resetGetFileObjectByIdStatus } from "../../../../objectStorage/slice";
import { ButtonComponent } from "../../../../ui/molecules/button/newButton";
import { Calendar } from "../../../../ui/molecules/calendar";
import CheckboxGroup from "../../../../ui/molecules/CheckBoxGroup";
import InputMultiSearch from "../../../../ui/molecules/input/InputMultiSearch";
import { MadfarmInput } from "../../../../ui/molecules/input/newInput";
import { ProtocolSearch } from "../../../../ui/molecules/ProtocolSearch";
import { MadfarmStaticSelect } from "../../../../ui/molecules/select/newSelect/static";
import { SingleCheckbox } from "../../../../ui/molecules/SingleCheckbox";
import TextArea from "../../../../ui/molecules/textArea";
import { PopupForm } from "../../../../ui/organisms/popupForm";
import { countries, DestinationOfficesType, entryMeansOptions, OptionType, regioniList } from "../../../../utils";
import { resetfindMeStatusIdle } from "../../../users/slice";
import { AddObjectPopupEntry } from "../../popup/addObjectEntry";
import { EntryProtocolUpdate, EntryProtocolUploadAttachmentFile, GetAllEntryProtocolObjects, GetEntryProtocolById, resetEntryProtocolErrors, resetEntryProtocolUpdateStatus, resetEntryProtocolUploadAttachmentFileStatus, resetEntryProtocolValidationStatus, resetEPObjCreationRequest, resetGetAllEntryProtocolObjectsStatus, setEPFileAndAtt, setFileToUpdate, setUpdatedEPFileAndAtt, setUpdatedFile, setUpdateEPCustomerIds, setUpdateEPCustomersNotRegistered, setUpdateEPDestinationOffice, setUpdateEPEntryChannel, setUpdateEPEntryObjectId, setUpdateEPLinkExistingProtocol, setUpdateEPNation, setUpdateEPObjectSpec, setUpdateEPRegion, setUpdateEPSend, setUpdateEPSender, setUpdateEPTotalPage, setUpdateEPUsersVisibility } from "../slice";

export function EditEntryLeft() {
    const dispatch = useAppDispatch()
    const entryProtocolState = useAppSelector(state => state.entryProtocol)
    const objectStorageState = useAppSelector(state => state.objectStorage)
    const userState = useAppSelector(state => state.users)
    const [viewable, setViewable] = useState<boolean>(false)
    const [selectedOffices, setSelectedOffices] = useState<DestinationOfficesType[]>([])
    const [objects, setObjects] = useState<OptionType[]>([])
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const [file, setFile] = useState<File | null>(null)
    const [officeSot, setOfficeSot] = useState<OptionType[]>([])


    let formData = new FormData();
    let attachmentFormData = new FormData();

    const handleTypesChange = (value: DestinationOfficesType) => {
        let currentOffices = [...selectedOffices]
        if (currentOffices.includes(value)) {
            currentOffices = currentOffices.filter(t => t !== value)
        }
        else {
            currentOffices.push(value)
        }
        setSelectedOffices(currentOffices)

        dispatch(setUpdateEPDestinationOffice(currentOffices))
    }

    useEffect(() => {
        if (entryProtocolState.getEntryProtocolByIdStatus === 'successfully' &&
            entryProtocolState.getEntryProtocolByIdResponse !== undefined
        ) {
            dispatch(setUpdatedEPFileAndAtt(entryProtocolState.getEntryProtocolByIdResponse.attachmentFile))
        }
    }, [entryProtocolState.getEntryProtocolByIdStatus])

    useEffect(() => {
        if (userState.findMeStatus === 'successfully') {
            dispatch(resetfindMeStatusIdle())
            if (userState.findMeResponse.headQuarterInfo !== null && userState.findMeResponse.headQuarterInfo !== undefined) {
                const newOption: OptionType = {
                    value: userState.findMeResponse.headQuarterInfo.code,
                    label: userState.findMeResponse.headQuarterInfo.code
                };

                setOfficeSot(prevOptions => {
                    const optionExists = prevOptions.some(option => option.value === newOption.value);
                    if (!optionExists) {
                        return [...prevOptions, newOption];
                    }
                    return prevOptions;
                });
            }
        }
    }, [userState.findMeStatus])

    useEffect(() => {
        setFile(entryProtocolState.fileToUpdate as File)
    }, [entryProtocolState.fileToUpdate])

    useEffect(() => {
        setViewable(entryProtocolState.entryProtocolUpdateRequest.usersVisibility)
        setSelectedOffices(entryProtocolState.entryProtocolUpdateRequest.destinationOffice as DestinationOfficesType[])
        dispatch(resetEntryProtocolErrors())
        dispatch(GetAllEntryProtocolObjects())
    }, [])

    useEffect(() => {
        if (entryProtocolState.getAllEntryProtocolObjectsStatus === 'successfully' &&
            entryProtocolState.getAllEntryProtocolObjectsResponse !== undefined
        ) {
            dispatch(resetGetAllEntryProtocolObjectsStatus())
            const data = entryProtocolState.getAllEntryProtocolObjectsResponse
            const newObjects: OptionType[] = data.map(d => {
                return { value: d.id, label: `${d.description} [${d.coding}]` } as OptionType
            })
            setObjects(newObjects)
        }
    }, [entryProtocolState.getAllEntryProtocolObjectsStatus])

    useEffect(() => {
        if (entryProtocolState.entryProtocolValidationStatus === 'successfully') {
            dispatch(resetEntryProtocolValidationStatus())
            formData.delete('file')
            if (file !== null)
                formData.append('file', file)
            formData.append('entryProtocolUpdateDTO', JSON.stringify(entryProtocolState.entryProtocolUpdateRequest))
            dispatch(EntryProtocolUpdate({ body: formData, id: entryProtocolState.entryProtocolIdToUpdate }))
        }
    }, [entryProtocolState.entryProtocolValidationStatus])

    useEffect(() => {
        if (entryProtocolState.entryProtocolUpdateStatus === 'successfully' &&
            entryProtocolState.entryProtocolUpdateResponse !== undefined
        ) {
            dispatch(resetEntryProtocolUpdateStatus())
            dispatch(setFileToUpdate(null))
            if (entryProtocolState.entryProtocolUpdateResponse !== null &&
                entryProtocolState.entryProtocolUpdateResponse !== '' &&
                entryProtocolState.entryProtocolUpdateResponse) {
                dispatch(GetFileObjectById(entryProtocolState.entryProtocolUpdateResponse))
            }

            if (entryProtocolState.entryProtocolUpdateFileAndAtt.length > 0) {

                const attF = entryProtocolState.entryProtocolUpdateFileAndAtt[0]
                dispatch(setEPFileAndAtt(entryProtocolState.entryProtocolUpdateFileAndAtt.slice(1)))
                if (attF !== undefined && attF && attF !== null) {
                    if (attF.file !== undefined && attF.file) {
                        attachmentFormData.delete('file')
                        attachmentFormData.append('file', attF.file)
                        attachmentFormData.append('attachmentFileDTO', JSON.stringify({ attachmentId: attF.attachmentId }))
                        dispatch(EntryProtocolUploadAttachmentFile({ data: attachmentFormData, id: entryProtocolState.entryProtocolIdToUpdate }))
                    }
                }
            }
        }
    }, [entryProtocolState.entryProtocolUpdateStatus])

    useEffect(() => {
        if (entryProtocolState.entryProtocolUploadAttachmentFileStatus === 'successfully') {
            dispatch(resetEntryProtocolUploadAttachmentFileStatus())
            if (entryProtocolState.entryProtocolUpdateFileAndAtt.length > 0) {
                const attF = entryProtocolState.entryProtocolUpdateFileAndAtt[0]
                dispatch(setEPFileAndAtt(entryProtocolState.entryProtocolUpdateFileAndAtt.slice(1)))

                if (attF !== undefined && attF && attF !== null) {
                    if (attF.file !== undefined && attF.file) {
                        attachmentFormData.delete('file')
                        attachmentFormData.append('file', attF.file)
                        attachmentFormData.append('attachmentFileDTO', JSON.stringify({ attachmentId: attF.attachmentId }))
                        dispatch(EntryProtocolUploadAttachmentFile({ data: attachmentFormData, id: entryProtocolState.entryProtocolIdToUpdate }))
                    }
                }
            }
            else {
                dispatch(GetEntryProtocolById(entryProtocolState.entryProtocolIdToUpdate))
            }
        }
    }, [entryProtocolState.entryProtocolUploadAttachmentFileStatus])

    useEffect(() => {
        if (objectStorageState.getFileObjectByIdStatus === 'successfully' &&
            objectStorageState.getFileObjectByIdResponse !== undefined
        ) {
            dispatch(resetGetFileObjectByIdStatus())
            dispatch(setUpdatedFile(objectStorageState.getFileObjectByIdResponse))
        }
    }, [objectStorageState.getFileObjectByIdStatus])

    useEffect(() => {
        dispatch(setUpdateEPUsersVisibility(viewable))
    }, [viewable])

    return (
        <div className='pb-6'>
            <div className="protocol-header">
                <span className='title'>Modifica protocollo</span>
            </div>
            <div className='protocol-content flex flex-col gap-6'>
                <div className='grid grid-cols-2 gap-4'>
                    {
                        userState.findMeResponse.role === 'admin' ? (
                            <MadfarmInput
                                label={'Protocollo'}
                                disabled
                                value={entryProtocolState.entryProtocolUpdateRequest.headQuarter} />
                        ) : (
                            <MadfarmStaticSelect
                                noOptionsMessage="Nessun protocollo trovato"
                                placeholder={'Seleziona protocollo'}
                                options={officeSot}
                                disabled
                                value={entryProtocolState.entryProtocolUpdateRequest.headQuarter}
                                defaultValue={entryProtocolState.entryProtocolUpdateRequest.headQuarter}
                            />
                        )
                    }
                    <Calendar
                        label="Data protocollo"
                        disabled
                        selected={entryProtocolState.entryProtocolUpdateRequest.protocolDate}
                    />
                </div>
                <div className='grid grid-cols-2 gap-4'>
                    <MadfarmStaticSelect
                        label="Nazione"
                        noOptionsMessage="Nessuna nazione trovata"
                        placeholder={'Seleziona nazione'}
                        options={countries}
                        onChange={(value) => {
                            //@ts-ignore
                            dispatch(setUpdateEPNation(value !== null ? value.value : null))
                        }}
                        value={entryProtocolState.entryProtocolUpdateRequest.nation}
                    />
                    <MadfarmStaticSelect
                        label="Regione"
                        error={entryProtocolState.entryProtocolErrors.region}
                        errorLabel='Regione mancante'
                        placeholder={'Seleziona regione'}
                        options={regioniList}
                        onChange={(value) => {
                            //@ts-ignore
                            dispatch(setUpdateEPRegion(value !== null ? value.value : null))
                        }}
                        value={entryProtocolState.entryProtocolUpdateRequest.region}
                        noOptionsMessage="Nessuna regione trovata"
                    />
                </div>
                <div className='grid grid-cols-2 gap-4'>
                    <InputMultiSearch
                        defaultClientIds={entryProtocolState.entryProtocolUpdateRequest.customerIds}
                        label={'Cliente'}
                        placeholder="Ragione sociale"
                        onSelectAddHandler={(res) => dispatch(setUpdateEPCustomerIds(res))}
                    />
                    <MadfarmInput
                        error={entryProtocolState.entryProtocolErrors.sender}
                        supportingText={entryProtocolState.entryProtocolErrors.sender ? 'Mittente mancante' : undefined}
                        label={'Mittente'}
                        placeholder="Mittente dei documenti da protocollare"
                        value={entryProtocolState.entryProtocolUpdateRequest.sender}
                        onChangeText={(text) => dispatch(setUpdateEPSender(text))}
                    />
                </div>
                <div className='grid grid-cols gap-4'>
                    <MadfarmInput
                        label={'Cliente non presente in archivio'}
                        placeholder="Indicare nel caso di cliente non ancora inserito in archivio"
                        value={entryProtocolState.entryProtocolUpdateRequest.customersNotRegistered}
                        onChangeText={(text) => dispatch(setUpdateEPCustomersNotRegistered(text))}
                    />
                </div>
                <div className='flex flex-row items-center gap-4'>
                    <div className={clsx("w-full", { "w-[85%]": userState.findMeResponse.role === "admin" })}>
                        <MadfarmStaticSelect
                            label="Oggetto (Da elenco)"
                            error={entryProtocolState.entryProtocolErrors.entryObjectId}
                            errorLabel='Oggetto mancante'
                            placeholder={'Seleziona...'}
                            options={objects}
                            value={entryProtocolState.entryProtocolUpdateRequest.entryObjectId}
                            onChange={(value) => {
                                //@ts-ignore
                                dispatch(setUpdateEPEntryObjectId(value !== null ? value.value : null))
                            }}
                            noOptionsMessage="Nessun oggetto trovato"
                        />
                    </div>
                    {
                        userState.findMeResponse.role === 'admin' &&
                        <div className="w-[15%] pt-5">
                            <ButtonComponent
                                variant='outline'
                                color='orange'
                                size='md'
                                iconPosition='off'
                                label='Crea oggetto'
                                onClick={() => setShowPopup(true)}
                                fullWidth
                            />
                        </div>
                    }
                </div>
                <div className='grid grid-cols'>
                    <TextArea
                        label="Specifiche oggetto"
                        placeholder="Integrazione all'oggetto indicato sopra"
                        onChangeText={(text) => dispatch(setUpdateEPObjectSpec(text))}
                    />
                </div>
                <div className="border h-[1px] border-neutral-200" />
                <div className='grid grid-cols-3 gap-4'>
                    <MadfarmInput
                        error={entryProtocolState.entryProtocolErrors.totalPage}
                        supportingText={entryProtocolState.entryProtocolErrors.totalPage ? 'Totale pagine mancante' : undefined}
                        label={'Totale pagine'}
                        placeholder="Specificare numero"
                        value={entryProtocolState.entryProtocolUpdateRequest.totalPage?.toString()}
                        onChangeText={(text) => dispatch(setUpdateEPTotalPage(Number(text)))}
                    />
                    <MadfarmStaticSelect
                        label="Mezzo entrata"
                        noOptionsMessage="Nessun risultato trovato"
                        error={entryProtocolState.entryProtocolErrors.entryChannel}
                        errorLabel='Mezzo mancante'
                        placeholder={'Seleziona...'}
                        options={entryMeansOptions}
                        onChange={(value) => {
                            //@ts-ignore
                            dispatch(setUpdateEPEntryChannel(value !== null ? value.value : null))
                        }}
                        value={entryProtocolState.entryProtocolUpdateRequest.entryChannel}
                    />
                    <Calendar
                        label="Data Spedizione/Invio"
                        errorLabel={entryProtocolState.entryProtocolErrors.send ? 'Data mancante' : undefined}
                        selected={entryProtocolState.entryProtocolUpdateRequest.send}
                        onChange={(date) => dispatch(setUpdateEPSend(date))}
                    />
                </div>
                <SingleCheckbox
                    checked={viewable}
                    setChecked={setViewable}
                    label='Protocollo visualizzabile da tutti gli utenti'
                />
                <div className="border h-[1px] border-neutral-200" />
                <span className="input-label" style={{ fontSize: '18px', fontWeight: 600 }}>
                    Aggancia a protocollo esistente
                </span>
                <ProtocolSearch
                    type='entry'
                    defaultValue={entryProtocolState.entryProtocolUpdateRequest.linkExistingProtocol}
                    onSelect={(value) => dispatch(setUpdateEPLinkExistingProtocol(value))}
                />
                <div className="border h-[1px] border-neutral-200" />
                <span className="input-label" style={{ fontSize: '18px', fontWeight: 600 }}>
                    Uffici di destinazione
                </span>
                <div className='grid grid-cols-3 gap-4'>
                    <CheckboxGroup
                        name="tipo_ufficio_1"
                        options={Object.values(DestinationOfficesType).splice(0, 4)}
                        selectedValues={selectedOffices}
                        onChange={handleTypesChange}
                        optionLabels={{
                            [DestinationOfficesType.DIREZIONE]: "Direzione",
                            [DestinationOfficesType.MON_PEC_DIREZIONE]: "Monitoraggio PEC Direzione",
                            [DestinationOfficesType.AMM_UNICO]: "Amministratore Unico (Fasano)",
                            [DestinationOfficesType.SCHEME_MANAGER_GG]: "Scheme Manager GG"
                        }}
                    />
                    <CheckboxGroup
                        name="tipo_ufficio_1"
                        options={Object.values(DestinationOfficesType).splice(4, 4)}
                        selectedValues={selectedOffices}
                        onChange={handleTypesChange}
                        optionLabels={{
                            [DestinationOfficesType.UFFICIO_CERT]: "Ufficio certificazione",
                            [DestinationOfficesType.UFFICIO_CONTR]: "Ufficio Controllo",
                            [DestinationOfficesType.UFFICIO_SEGR_TEC]: "Ufficio Segreteria Tecnica",
                            [DestinationOfficesType.UFFICIO_CONT_AMM]: "Ufficio Contabile Amministrativo"
                        }}
                    />
                    <CheckboxGroup
                        name="tipo_ufficio_2"
                        options={Object.values(DestinationOfficesType).splice(8, 4)}
                        selectedValues={selectedOffices}
                        onChange={handleTypesChange}
                        optionLabels={{
                            [DestinationOfficesType.SOT_IS]: "S.O.T. IS",
                            [DestinationOfficesType.SOT_PU]: "S.O.T. PU",
                            [DestinationOfficesType.SOT_BA]: "S.O.T. BA",
                            [DestinationOfficesType.SOT_CL]: "S.O.T. CL"
                        }}
                    />
                </div>
                {
                    entryProtocolState.entryProtocolErrors.destinationOffice && (
                        <span className="input-supporting-text pt-2" style={{ color: '#fd665b', justifyContent: 'left', display: 'flex' }}>Indica almeno un ufficio di destinazione</span>
                    )
                }

            </div>
            {
                showPopup && (
                    <PopupForm title='Aggiungi Oggetto' close={() => {
                        dispatch(resetEPObjCreationRequest())
                        setShowPopup(false)
                    }}>
                        <AddObjectPopupEntry close={() => {
                            dispatch(resetEPObjCreationRequest())
                            setShowPopup(false)
                        }} />
                    </PopupForm>
                )
            }
        </div>
    )
}